module.exports = __webpack_public_path__ + "img/horizontal_3_6_r_7005.13a42db2.png";